import { callApi } from '../../../Utils/Api/Api'; // Adjust import based on your project structure
import { getTokensFromStorage } from '../../../Utils/Auth/AuthToken';

const { accessToken } = getTokensFromStorage();
const routeName = '/rollouts/rollout-package/';

/**
 * Uploads a file and returns the processed result.
 * @param {File} file - The file to be uploaded.
 * @param fileType
 * @returns {Promise} - A promise that resolves with the API response or rejects with an error.
 */
export const generateRollout = async (file, fileType) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', fileType); // Add the file type

  const request = {
    endpoint: routeName,
    method: 'POST',
    data: formData,
    headers: {
      'Authorization': `Bearer ${accessToken}`,
    },
  };

  try {
    const response = await apiRequest(request);
    if (!response) {
      throw new Error('No response from server');
    }
    return response;
  } catch (e) {
    console.error('Error uploading file:', e.message);
    throw e;
  }
};

/**
 * Api Call Wrapper Method.
 * @param {object} request - Contains details like url headers method and data.
 * @returns {Promise} - A promise that resolves with the data or rejects with an error.
 */
const apiRequest = async (request) => {
  let response;

  try {
    response = await callApi(request.endpoint, request.method, request.data, request.headers);
  } catch (e) {
    response = { success: false, message: e.message };
  }

  return response;
};
